// import React from "react";
// import {
//   Card,
//   CardContent,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   TableContainer,
//   Paper,
// } from "@mui/material";
// import "./InvoiceFooter.scss";

// export default function InvoiceFooter({
//   banksdetails,
//   transactiondetails,
//   invoiceTranslate,
//   companiedDetails,
// }) {
//   return (
//     <div className="footer-section">
//       {/* 🔹 Komenti */}
//       <Card className="footer-section__comment-card">
//         <CardContent>
//           <p className="footer-section__comment-label">Koment:</p>
//           <p className="footer-section__comment-text">
//             {" "}
//             {transactiondetails && transactiondetails.length > 0 ? (
//               transactiondetails[0].PaymentOptions === 0 ? (
//                 <div>
//                   <p style={{ fontSize: "12px" }}>{invoiceTranslate.desc1}</p>
//                   {transactiondetails[0].Comment &&
//                   transactiondetails[0].Comment != null ? (
//                     <p style={{ fontSize: "12px" }}>
//                       {invoiceTranslate.comment}:{" "}
//                       {transactiondetails[0].Comment &&
//                         transactiondetails[0].Comment}{" "}
//                     </p>
//                   ) : null}
//                 </div>
//               ) : (
//                 <div>
//                   <p style={{ fontSize: "12px" }}>{invoiceTranslate.desc2}</p>
//                   {transactiondetails[0].Comment &&
//                   transactiondetails[0].Comment != null ? (
//                     <p style={{ fontSize: "12px" }}>
//                       {invoiceTranslate.comment}:{" "}
//                       {transactiondetails[0].Comment &&
//                         transactiondetails[0].Comment}{" "}
//                     </p>
//                   ) : null}
//                 </div>
//               )
//             ) : null}
//           </p>
//         </CardContent>
//       </Card>

//       {/* 🔹 Nënshkrimet (statike) */}
//       <div className="footer-section__signatures">
//         <div className="footer-section__signature">
//           <div className="footer-section__electronic-seal">
//             <label className="footer-section__seal-company">
//               {companiedDetails && companiedDetails.length > 0
//                 ? companiedDetails[0].CompanyName
//                 : ""}
//             </label>
//             <label className="footer-section__seal-confirm">
//               {invoiceTranslate.confirm}
//             </label>
//             <label className="footer-section__seal-el">
//               {invoiceTranslate.vulaEl}
//             </label>
//           </div>

//           <div className="footer-section__user-signature">
//             {/* <label className="footer-section__user-name">
//               {transactiondetails &&
//               transactiondetails.length > 0 &&
//               transactiondetails[0].CreatedByUser
//                 ? transactiondetails[0].CreatedByUser.split("@")[0]
//                 : ""}
//             </label> */}
//             <label className="footer-section__faturoi">
//               {invoiceTranslate.faturoi}:
//             </label>
//           </div>
//         </div>

//         <div className="footer-section__signature">
//           <div className="footer-section__signature-line"></div>
//           <p className="footer-section__signature-name">
//             {" "}
//             {invoiceTranslate.dergoi}:
//           </p>
//         </div>

//         <div className="footer-section__signature">
//           <div className="footer-section__signature-line"></div>
//           <p className="footer-section__signature-name">
//             {" "}
//             {invoiceTranslate.pranoi}:
//           </p>
//         </div>
//       </div>

//       {/* 🔹 Detajet e Bankës */}
//       <Card className="footer-section__bank-card">
//         <CardContent>
//           <TableContainer
//             component={Paper}
//             className="footer-section__table-container"
//           >
//             <Table className="footer-section__table">
//               <TableHead>
//                 <TableRow>
//                   <TableCell> {invoiceTranslate.bank}</TableCell>
//                   <TableCell> {invoiceTranslate.accName}</TableCell>
//                   <TableCell> {invoiceTranslate.accNumber}</TableCell>
//                   <TableCell> {invoiceTranslate.swift}</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {(banksdetails || []).map((bank, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{bank.AccountName}</TableCell>
//                     <TableCell>
//                       {" "}
//                       {companiedDetails &&
//                       companiedDetails.length > 0 &&
//                       companiedDetails[0].CompanyName
//                         ? companiedDetails[0].CompanyName
//                         : ""}
//                     </TableCell>
//                     <TableCell>{bank.IBAN && bank.IdentificationNumber
//                                   ? `${bank.IBAN} ${bank.IdentificationNumber}`
//                                   : ""}</TableCell>
//                     <TableCell>{bank.SWIFT}</TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//     </div>
//   );
// }
import React from "react";
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
} from "@mui/material";
import "./InvoiceFooter.scss";

export default function InvoiceFooter({
  banksdetails,
  transactiondetails,
  invoiceTranslate,
  companiedDetails,
}) {
  const hasTransaction = transactiondetails && transactiondetails.length > 0;
  const transaction = hasTransaction ? transactiondetails[0] : null;

  return (
    <div className="footer-section">
      {/* 🔹 Komenti */}
      <Card className="footer-section__comment-card">
        <CardContent>
          <div className="footer-section__comment">
            {transaction && (
              <div className="footer-section__comment-text">
                <p style={{ fontSize: "12px" }}>
                  {transaction.PaymentOptions === 0
                    ? invoiceTranslate.desc1
                    : invoiceTranslate.desc2}
                </p>
                {transaction.Comment && (
                  <p style={{ fontSize: "12px" }}>
                    {invoiceTranslate.comment}: {transaction.Comment}
                  </p>
                )}
              </div>
            )}
          </div>
        </CardContent>
      </Card>

      {/* 🔹 Nënshkrimet */}
      <div className="footer-section__signatures">
        <div className="footer-section__signature">
          <div className="footer-section__electronic-seal">
            <label className="footer-section__seal-company">
              {companiedDetails?.[0]?.CompanyName || ""}
            </label>
            <label className="footer-section__seal-confirm">
              {invoiceTranslate.confirm}
            </label>
            <label className="footer-section__seal-el">
              {invoiceTranslate.vulaEl}
            </label>
          </div>

          <div className="footer-section__user-signature">
            <label className="footer-section__faturoi">
              {invoiceTranslate.faturoi}:
            </label>
          </div>
        </div>

        <div className="footer-section__signature">
          <div className="footer-section__signature-line"></div>
          <p className="footer-section__signature-name">
            {invoiceTranslate.dergoi}:
          </p>
        </div>

        <div className="footer-section__signature">
          <div className="footer-section__signature-line"></div>
          <p className="footer-section__signature-name">
            {invoiceTranslate.pranoi}:
          </p>
        </div>
      </div>

      {/* 🔹 Tabela e Bankës */}
      <Card className="footer-section__bank-card">
        <CardContent>
          <TableContainer component={Paper}>
            <Table className="footer-section__table">
              <TableHead>
                <TableRow>
                  <TableCell>{invoiceTranslate.bank}</TableCell>
                  <TableCell>{invoiceTranslate.accName}</TableCell>
                  <TableCell>{invoiceTranslate.accNumber}</TableCell>
                  <TableCell>{invoiceTranslate.swift}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(banksdetails || []).map((bank, index) => (
                  <TableRow key={index}>
                    <TableCell>{bank.AccountName}</TableCell>
                    <TableCell>
                      {companiedDetails?.[0]?.CompanyName || ""}
                    </TableCell>
                    <TableCell>
                      {bank.IBAN && bank.IdentificationNumber
                        ? `${bank.IBAN} ${bank.IdentificationNumber}`
                        : ""}
                    </TableCell>
                    <TableCell>{bank.SWIFT}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </div>
  );
}
